import type { BlotterTableState, TabProps, TabsState } from '@talos/kyoko';
import type { LayoutSpec, PanelConfig } from '../../../../types/LayoutConfig';
import {
  getMobileLayoutBasePath,
  getMobileLayoutPanelRoute,
  getMobileLayoutPanelTabRoute,
} from '../../mobileLayoutRoutes';

type LayoutAddressable = Pick<LayoutSpec, 'id' | 'group'>;
export type PanelConfigWithTabs<T extends TabProps> = PanelConfig & { tabs?: TabsState<T> | undefined };
const TRADING_SECTION_ID = 'trading';

export const getTradingLayoutBasePath = (layout: LayoutAddressable) =>
  getMobileLayoutBasePath(TRADING_SECTION_ID, layout);

export const getTradingPanelRoute = (layout: LayoutAddressable, panelId: string) =>
  getMobileLayoutPanelRoute(TRADING_SECTION_ID, layout, panelId);

export const getBlotterTabRoute = (layout: LayoutAddressable, panelId: string, tabId: string) =>
  getMobileLayoutPanelTabRoute(TRADING_SECTION_ID, layout, panelId, tabId);

/** Pull persisted tab state out of the panel config, if the panel is one of the blotter types that supports tabs. */
export function getTabsStateFromPanelConfig<T extends TabProps>(
  config: PanelConfigWithTabs<T> | undefined
): TabsState<T> | undefined {
  return config?.tabs;
}

/** Pull persisted blotter-table state out of the panel config, when present. */
export function getBlotterTablesStateFromPanelConfig(
  config: PanelConfig | undefined
): Record<string, BlotterTableState> | undefined {
  if (config != null && 'blotterTablesState' in config && config.blotterTablesState != null) {
    return config.blotterTablesState;
  }
  return undefined;
}
